import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "../../assets/Icons/cross.svg";
import Translate from "../Multilanguage/Translate";
const CurrentPasswordModal = (props) => {
  const [input, setInput] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);

  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (props.show) {
      setInput("");
      props.setValues((prev) => ({ ...prev, currentPassword: "" }));
    }
  }, [props.show, props.setValues]);

  const validationPasword = () => {
    const {currentPassword} = props?.values
    let validationStatus =  true;
    let errors = {}
    if(!currentPassword){
        errors.currentPassword="Current password is required!"
        validationStatus = false
    }
    props?.setErrors(errors)
    return validationStatus
  }

const submitButton = (e) =>{
  e.preventDefault();
  if (isSubmitting) return;
  setIsSubmitting(true);
   if (validationPasword()===true){
    const result = props?.updateAccountDetails?.();
    if (result && typeof result.finally === 'function') {
      result.finally(() => {
        setIsSubmitting(false);
        props.setValues({ ...props.values, currentPassword: "" });
      });
    } else {
      setIsSubmitting(false);
      props.setValues({ ...props.values, currentPassword: "" });
    }
  } else {
    setIsSubmitting(false);
  }
}

const closeHandler = () => {
  props.setPasswordModal(false)
  props.setValues((prev) => ({ ...prev, currentPassword: "" }));
}
  
  return (
    <div className={`currentPasswordModal ${projectInfo?.projectConfig?.config?.TEMPLATE === 'TEMPLATE_12' ? 'kids' : ''}`}>
      <div className="overlayModal"></div>
      <div className="currentPasswordContainer">
        <div className="closePasswordContainer" onClick={closeHandler}><CloseIcon/></div>
        <label htmlFor="currentPassword"><Translate textKey={'enter_current_password'} /></label>
        <input
          type="password"
          name="currentPassword"
          id="currentPassword"
          value={props?.values?.currentPassword || input}
          autoComplete="off"
          onChange={(e) => {
            setInput(e.target.value);
            props?.handleUpdateItem(e);
          }}
        />
        {props?.errors?.currentPassword && <span className="error">{props?.errors?.currentPassword}</span>}
        <div className="buttonContainer" onClick={(e)=>submitButton(e)}>
          <div className="background"></div>
          <button disabled={isSubmitting}>
            {isSubmitting ? <Translate textKey={'processing'} /> : <Translate textKey={'update'} />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CurrentPasswordModal;
